module.exports = __webpack_public_path__ + "img/16800.3eeec474.jpg";